/**
 * Normalize MongoDB ObjectId values from API responses.
 * Handles plain strings, `{ $oid }`, and `{ _id }` shapes.
 */

export type MongoIdLike =
  | string
  | { $oid?: string; _id?: string | { $oid?: string } }
  | null
  | undefined;

export function extractMongoId(value: MongoIdLike): string | null {
  if (value == null) return null;
  if (typeof value === 'string') return value;

  if (typeof value === 'object') {
    if (typeof value.$oid === 'string') return value.$oid;
    if (typeof value._id === 'string') return value._id;
    if (value._id && typeof value._id === 'object' && typeof value._id.$oid === 'string') {
      return value._id.$oid;
    }
  }

  return null;
}

/** First teaching standard id on a teacher record. */
export function extractTeachingStandardId(
  teachingStandards: unknown[] | undefined,
): string | null {
  if (!teachingStandards?.length) return null;
  return extractMongoId(teachingStandards[0] as MongoIdLike);
}
